module.exports = __webpack_public_path__ + "static/b6-cda4dbef64590647b4441257e790da38.jpg";